export default __webpack_public_path__ + "static/media/hand.a1f3e25e.svg";